import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export async function submitLead(payload) {
  const { data } = await api.post("/leads", payload);
  return data;
}

export async function adminLogin(password) {
  const { data } = await api.post("/admin/login", { password });
  return data;
}

export async function fetchLeads(token) {
  const { data } = await api.get("/admin/leads", {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
}
